import { Component, OnInit } from '@angular/core';
import { FormBuilder} from '@angular/forms';
import { ApiService } from '../api.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-assesment-form',
  templateUrl: './assesment-form.component.html',
  styleUrls: ['./assesment-form.component.scss']
})
export class AssesmentFormComponent implements OnInit {

  assessmentForm: any = {};
  isReady = false;
  public isRequiredFileUpload:boolean = true;
  public firstName = "";
  public firstNameError = "";
  public lastName = "";
  public lastNameError = "";
  public email = "";
  public emailError = "";
  public activities = "";
  public activitiesError = "";
  private file;
  public fileError = "";
  public submitted: boolean = false;
  private emailValidation:boolean = false;
  public responseMessage = ''
  
  
  todayDate: string;
  public empId = "";
  public empIdError = "";
  public doeError = "";

  public newAssessment: Object = {
    "Annual Exam / Yearly Physical": 115,
    "Complete a Half Marathon or Triathlon": 25,
    "Annual Preventive Exams": 25,
    "Preventive Vaccines": 10,
    "Participate in a Formal Weight Management Program": 10,
    "Work with a Nutritionist": 10,
    "Work with a Personal Trainer": 10,
    "Participate in a Team Sport": 10,
    "Participate in a Physical Challenge": 10,
    "Participate in a Formal Smoking Cessation Program": 50,
    "Complete a Full Marathon or Triathlon": 50,
    "Attend an NAR-sponsored Wellness-themed Lunch & Learn": 5,
    "Attend an NAR-sponsored Financial Wellness class": 5,
    "Regularly contribute to a 401(k) or other Retirement plan": 10,
    "Foster(ed) or adopted a Shelter Pet": 50,
    "Regularly compost": 10,
    "Regularly recycle": 10,
    "Participate in a Community Garden": 10,
    "Own an Electric or Hybrid car": 10,
    "Volunteer in my community": 10,
    "I cook meals at home 5x/week+" :10,

      "I have a home garden": 10, 
    "I own energy efficient home appliances": 10, 
    "I have solar panels in my home": 10, 
    "I have a low flush toilet(s)": 10, 
    "I donate to food banks": 10, 
    "I donate used household items to charity orgs": 10, 
  }

  public newAssessmentkeys = [
    { name: "Annual Exam / Yearly Physical", point: 115, required: true },
    { name: "Complete a Half Marathon or Triathlon", point: 25, required: true },
    { name: "Annual Preventive Exams", point: 25, required: true },
    { name: "Preventive Vaccines", point: 10, required: true },
    { name: "Participate in a Formal Weight Management Program", point: 10, required: false },
    { name: "Work with a Nutritionist", point: 10, required: false },
    { name: "Work with a Personal Trainer", point: 10, required: false },
    { name: "Participate in a Team Sport", point: 10, required: false },
    { name: "Participate in a Physical Challenge", point: 10, required: false },
    { name: "Participate in a Formal Smoking Cessation Program", point: 50, required: true },
    { name: "Complete a Full Marathon or Triathlon", point: 50, required: true },
    { name: "Attend an NAR-sponsored Wellness-themed Lunch & Learn", point: 5, required: false },
    { name: "Attend an NAR-sponsored Financial Wellness class", point: 5, required: false },
    { name: "Regularly contribute to a 401(k) or other Retirement plan", point: 10, required: false },
    { name: "Foster(ed) or adopted a Shelter Pet", point: 50, required: true },
    { name: "Regularly compost", point: 10, required: false },
    { name: "Regularly recycle", point: 10, required: false },
    { name: "Participate in a Community Garden", point: 10, required: false },
    { name: "Own an Electric or Hybrid car", point: 10, required: false },
    { name: "Volunteer in my community", point: 10, required: false },

    { name: "I cook meals at home 5x/week+", point: 5, required: false },
    { name: "I have a home garden", point: 10, required: false },
    { name: "I own energy efficient home appliances", point: 10, required: false },
    { name: "I have solar panels in my home", point: 10, required: false },
    { name: "I have a low flush toilet(s)", point: 10, required: false },
    { name: "I donate to food banks", point: 10, required: false },
    { name: "I donate used household items to charity orgs", point: 10, required: false }
  ];

    public newAssessmentLw: Object = {
     "Log any activity": 50 ,
  "Complete a video class": 200 ,
  "Join a weekly challenge": 500 ,
  "Earn badges": 100 ,
  "Cross 10,000 calories burnt": 1000 ,
  "Cross 25,000 calories burnt": 2000 ,

  "Complete an Health assessment": 500 ,
  "Complete a Annual physical with physician": 2000 ,
  "Complete a Health screening results with physician": 1000,
  "Complete an Eye exam": 2000,
  "Complete a Preventive wellness screening": 1000,
  "Take a Flu shot": 1000
  }


  public newAssessmentkeysLw = [

  { name: "Log any activity", point: 50, required: false },
  { name: "Complete a video class", point: 200, required: false },
  { name: "Join a weekly challenge", point: 500, required: false },
  { name: "Earn badges", point: 100, required: false },
  { name: "Cross 10,000 calories burnt", point: 1000, required: false },
  { name: "Cross 25,000 calories burnt", point: 2000, required: false },

  { name: "Complete an Health assessment", point: 500, required: false },
  { name: "Complete a Annual physical with physician", point: 2000, required: false },
  { name: "Complete a Health screening results with physician", point: 1000, required: false },
  { name: "Complete an Eye exam", point: 2000, required: false },
  { name: "Complete a Preventive wellness screening", point: 1000, required: false },
  { name: "Take a Flu shot", point: 1000, required: false }
  ];
  public mode = '';

  constructor(private fb: FormBuilder, private httpService: ApiService, private route: ActivatedRoute) {
  }

  ngOnInit(): void {
  // this.route.queryParams.subscribe(params => {
  //   this.mode = params['mode'] || '';
  //   this.isReady = true; // ✅ mark ready AFTER getting params
  // });
    const mode = this.route.snapshot.queryParamMap.get('mode');
     this.mode = mode || '';

   const today = new Date();
  this.todayDate = today.toISOString().split('T')[0];
  }

  get isSubmissionMode(): boolean {
  return this.mode === 'submission';
}


  onFileSelected(event) {
    const file: File = event.target.files[0];
    this.file = file;
  }

  checkPoints(e) {
    this.activities = e.target.value;
    this.newAssessmentkeys.map((obj) => {
      if (obj.name == e.target.value) {
        this.isRequiredFileUpload = obj.required;
        if(this.isRequiredFileUpload){
        }else{
          this.file = '';
        }
      }
    });
  }

  submitForm() {
    
    let regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.submitted = true;

    if (this.assessmentForm.hasOwnProperty('firstName')) {
      this.firstNameError = ""
    } else {
      this.firstNameError = "First Name is Required";
    }

    if (this.assessmentForm.hasOwnProperty('lastName')) {
      this.lastNameError = "";
    } else {
      this.lastNameError = "Last Name is Required";
    }

    if (this.assessmentForm.hasOwnProperty('email')) {
      if (!regex.test(this.assessmentForm.email)) {
        this.emailError = "Email is not Valid";
        this.emailValidation = false;
      } else{
        this.emailValidation = true;
        this.emailError = "";
      }
    }
    else {
      this.emailError = "Email is Required";
    }

    if(this.activities != ''){
      this.activitiesError = "";
    }else{
      this.activitiesError = "Select Activity";
    }

    if(this.isRequiredFileUpload && this.file == undefined){
      this.fileError = 'File is Required';
    }else if(this.isRequiredFileUpload && this.file == ''){
      this.fileError = 'File is Required';
    }else{
      this.fileError = '';
    }

    if (this.isRequiredFileUpload && this.assessmentForm.hasOwnProperty('firstName') && this.assessmentForm.hasOwnProperty('lastName') && this.assessmentForm.hasOwnProperty('email') && this.activities != '' && this.file != undefined  && this.file != '' && this.emailValidation) {
      this.callAssessmentFormRequiredApi();
    } 

    if (!this.isRequiredFileUpload && this.assessmentForm.hasOwnProperty('firstName') && this.assessmentForm.hasOwnProperty('lastName') && this.assessmentForm.hasOwnProperty('email') && this.activities != '' && this.emailValidation) {
      this.callAssessmentFormNonRequiredApi();
    }
  }


  callAssessmentFormRequiredApi() {
    this.mode = 'indeterminate';
    let url = "assessment/form";
    const formData = new FormData();
    formData.append("firstName",this.assessmentForm.firstName);
    formData.append("lastName",this.assessmentForm.lastName);
    formData.append("email",this.assessmentForm.email);
    formData.append("newAssessmentValue",this.activities);
    formData.append("newAssessmentPoint",this.newAssessment[this.activities]);
    formData.append("isFile",this.file?"true":"false");
    formData.append("file",this.file?this.file:'');
    this.httpService.postFormData(url,formData).subscribe(res => {
      if(res['status']){
        this.mode = 'determinate';
        this.responseMessage = res.data.message;
        setTimeout(()=>{
          this.responseMessage = ''
        },4000);
        this.assessmentForm = {}
      }else{
        this.mode = 'determinate';
        this.responseMessage = res.data.message;
        setTimeout(()=>{
          this.responseMessage = ''
        },4000);
        this.assessmentForm = {}
      }
    });
  }

  callAssessmentFormNonRequiredApi() {
    this.mode = 'indeterminate';
    let url = "assessment/form";
    const formData = new FormData();
    formData.append("firstName",this.assessmentForm.firstName);
    formData.append("lastName",this.assessmentForm.lastName);
    formData.append("email",this.assessmentForm.email);
    formData.append("newAssessmentValue",this.activities);
    formData.append("newAssessmentPoint",this.newAssessment[this.activities]);
    formData.append("isFile",this.file?"true":"false");
    formData.append("file",this.file);
    this.httpService.postFormData(url,formData).subscribe(res => {
      if(res['status']){
        this.mode = 'determinate';
        this.responseMessage = res.data.message;
        setTimeout(()=>{
          this.responseMessage = ''
        },4000);
        this.assessmentForm = {}
      }else{
        this.mode = 'determinate';
        this.responseMessage = res.data.message;
        setTimeout(()=>{
          this.responseMessage = ''
        },4000);
        this.assessmentForm = {}
      }
    });
  }


 submitLwForm() {
    
    let regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.submitted = true;

    if (this.assessmentForm.hasOwnProperty('firstName')) {
      this.firstNameError = ""
    } else {
      this.firstNameError = "First Name is Required";
    }

    if (this.assessmentForm.hasOwnProperty('lastName')) {
      this.lastNameError = "";
    } else {
      this.lastNameError = "Last Name is Required";
    }
    if (this.assessmentForm.hasOwnProperty('empId')) {
      this.empIdError = "";
    } else {
      this.empIdError = "Employee Id is Required";
    }
    if (this.assessmentForm.hasOwnProperty('doe')) {
      this.doeError = "";
    } else {
      this.doeError = "Date of Exam is Required";
    }

    if (this.assessmentForm.hasOwnProperty('email')) {
      if (!regex.test(this.assessmentForm.email)) {
        this.emailError = "Email is not Valid";
        this.emailValidation = false;
      } else{
        this.emailValidation = true;
        this.emailError = "";
      }
    }
    else {
      this.emailError = "Email is Required";
    }

    if(this.activities != ''){
      this.activitiesError = "";
    }else{
      this.activitiesError = "Select Exam Type";
    }

    // if(this.isRequiredFileUpload && this.file == undefined){
    //   this.fileError = 'File is Required';
    // }else if(this.isRequiredFileUpload && this.file == ''){
    //   this.fileError = 'File is Required';
    // }else{
    //   this.fileError = '';
    // }

    if (this.isRequiredFileUpload && this.assessmentForm.hasOwnProperty('firstName') && this.assessmentForm.hasOwnProperty('lastName') && this.assessmentForm.hasOwnProperty('email') && this.activities != '' && this.emailValidation) {
      this.callAssessmentFormRequiredApiLw();
    } 

    if (!this.isRequiredFileUpload && this.assessmentForm.hasOwnProperty('firstName') && this.assessmentForm.hasOwnProperty('lastName') && this.assessmentForm.hasOwnProperty('email') && this.activities != '' && this.emailValidation) {
      this.callAssessmentFormNonRequiredApiLw();
    }
  }


  callAssessmentFormRequiredApiLw() {
    this.mode = 'indeterminate';
    let url = "assessment/form";
    const formData = new FormData();
    formData.append("firstName",this.assessmentForm.firstName);
    formData.append("lastName",this.assessmentForm.lastName);
    formData.append("email",this.assessmentForm.email);
    formData.append("empId",this.assessmentForm.empId);
    formData.append("doe",this.assessmentForm.doe);
    formData.append("newAssessmentValue",this.activities);
    formData.append("newAssessmentPoint",this.newAssessmentLw[this.activities]);
    formData.append("isFile",this.file?"true":"false");
    formData.append("file",this.file?this.file:'');
    this.httpService.postFormData(url,formData).subscribe(res => {
      if(res['status']){
        this.mode = 'determinate';
        this.responseMessage = res.data.message;
        setTimeout(()=>{
          this.responseMessage = ''
        },4000);
        this.assessmentForm = {}
      }else{
        this.mode = 'determinate';
        this.responseMessage = res.data.message;
        setTimeout(()=>{
          this.responseMessage = ''
        },4000);
        this.assessmentForm = {}
      }
    });
  }

  callAssessmentFormNonRequiredApiLw() {
    this.mode = 'indeterminate';
    let url = "assessment/form";
    const formData = new FormData();
    formData.append("firstName",this.assessmentForm.firstName);
    formData.append("lastName",this.assessmentForm.lastName);
    formData.append("email",this.assessmentForm.email);
    formData.append("empId",this.assessmentForm.empId);
    formData.append("doe",this.assessmentForm.doe);
    formData.append("newAssessmentValue",this.activities);
    formData.append("newAssessmentPoint",this.newAssessmentLw[this.activities]);
    formData.append("isFile",this.file?"true":"false");
    formData.append("file",this.file);
    this.httpService.postFormData(url,formData).subscribe(res => {
      if(res['status']){
        this.mode = 'determinate';
        this.responseMessage = res.data.message;
        setTimeout(()=>{
          this.responseMessage = ''
        },4000);
        this.assessmentForm = {}
      }else{
        this.mode = 'determinate';
        this.responseMessage = res.data.message;
        setTimeout(()=>{
          this.responseMessage = ''
        },4000);
        this.assessmentForm = {}
      }
    });
  }
}
